import { render, staticRenderFns } from "./blocklist.vue?vue&type=template&id=9995364e&scoped=true&"
import script from "./blocklist.vue?vue&type=script&lang=js&"
export * from "./blocklist.vue?vue&type=script&lang=js&"
import style0 from "./blocklist.vue?vue&type=style&index=0&id=9995364e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9995364e",
  null
  
)

export default component.exports